import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { Drawer } from '@mui/material';
import { MenuOpen as MenuOpenIcon } from '@mui/icons-material';
import UserSettings from './UserSettings';
import { setIsStudyLaunching } from 'store/studies';
import { getIsStudyLaunching } from 'store/studies/selectors';
import KorioSVG from 'assets/korio.svg';
import AllStudiesSVG from 'assets/studies.svg';
import './styles.scss';

const NavigationPanel = () => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(true);

  const isStudyLaunching = useSelector(getIsStudyLaunching);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  useEffect(() => {
    const onPageShow = ({ persisted }) => {
      if (persisted) dispatch(setIsStudyLaunching(false));
    };

    window.addEventListener('pageshow', onPageShow);

    return () => {
      window.removeEventListener('pageshow', onPageShow);
    };
  }, [dispatch]);

  const classes = useMemo(() => {
    return classNames({
      collapsed: !isOpen,
      launching: isStudyLaunching,
    }, 'navigation-panel');
  }, [isOpen, isStudyLaunching]);

  return (
    <Drawer
      className={classes}
      variant="permanent">
      <header>
        <img className="app-logo" src={KorioSVG} />

        <div
          className="toggle-button"
          onClick={toggle}>
          <MenuOpenIcon />
        </div>
      </header>

      <section>
        <ul>
          <li>
            <a href="/" className="active">
              <div><img src={AllStudiesSVG} /></div>
              <div>Studies</div>
            </a>
          </li>
        </ul>
      </section>

      <footer>
        <UserSettings isCollapsed={!isOpen} />
      </footer>
    </Drawer>
  );
};

export default NavigationPanel;
